var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"home",attrs:{"id":"home"}},[_c('Banner'),_c('AboutUs'),_c('Contact'),_c('insight'),_c('Career'),_c('Testimonial'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }